import React, { Fragment } from 'react';
import { Section } from './ProductPage';
import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import { styled } from 'linaria/react';
import { theme } from '../Theming/Theming';

const backgroundColor = '#F5F5F5';

const ImageWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  ${theme.below.md} {
    flex-direction: column;
  }
`;

const MockThumbWrapper = styled('div')`
  width: 15%;
  ${theme.below.md} {
    order: 2;
    width: 100%;
    margin-top: 1rem;
    display: flex;
    max-width: 320px;
    margin: 10px auto;
  }
`;

const MockImage = styled('div')`
  width: 82%;
  padding-top: 100%;
  background: ${backgroundColor};
  ${theme.below.md} {
    order: 1;
    width: 100%;
  }
`;

const MockThumb = styled('div')`
  padding-top: 100%;
  margin-bottom: 1rem;
  background: ${backgroundColor};
  ${theme.below.md} {
    width: 25%;
    padding-top: 20%;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
`;

export default function ProductPageLoadingState() {
  return (
    <Fragment>
      <div
        style={{
          width: '100%'
        }}
      >
        <LoadingLine
          heightPx={14}
          widthRem={15}
          style={{
            marginBottom: '14px'
          }}
        />
      </div>
      <Section className="product-images-wrapper">
        <ImageWrapper>
          <MockThumbWrapper>
            <MockThumb />
            <MockThumb />
            <MockThumb />
            <MockThumb />
          </MockThumbWrapper>
          <MockImage />
        </ImageWrapper>
      </Section>
      <Section className="product-info-wrapper">
        <LoadingLine
          heightPx={24}
          widthRem={15}
          style={{
            marginBottom: '12px'
          }}
        />
        <LoadingLine
          heightPx={16}
          style={{
            marginBottom: '14px'
          }}
        />
        <LoadingLine
          heightPx={12}
          widthRem={30}
          count={4}
          randomizeWidthBy={10}
          style={{
            marginBottom: '8px'
          }}
        />
        <LoadingLine
          heightPx={16}
          style={{
            marginBottom: '14px'
          }}
        />
        <LoadingLine
          heightPx={36}
          widthRem={20}
          style={{
            marginTop: '16px',
            marginBottom: '14px'
          }}
        />
        <LoadingLine
          heightPx={16}
          style={{
            marginBottom: '14px'
          }}
        />
        <LoadingLine
          heightPx={36}
          widthRem={20}
          style={{
            marginTop: '16px',
            marginBottom: '14px'
          }}
        />
        <LoadingLine
          heightPx={20}
          style={{
            marginBottom: '14px'
          }}
        />
        <LoadingLine
          heightPx={54}
          widthRem={50}
          style={{
            marginTop: '16px',
            marginBottom: '14px'
          }}
        />
      </Section>
    </Fragment>
  );
}
